import { ACCOUNTS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

async function ForgotPassword(email, whiteLabelID) {
  try {  
		const url = `/${ACCOUNTS_PREFIX}/forgotPassword/${email}`;
		if (whiteLabelID) {
			await postApi(url, { email, whiteLabelID }, {}, false);
		} else {
			await postApi(url, { email }, {}, false);
		}
		return true;
	} catch (err) {
		throw err;
	}
}

export default ForgotPassword;
